import clsx from 'clsx';
import type { ReactNode } from 'react';

export function Avatar({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <span
      className={clsx(
        'relative inline-flex shrink-0 overflow-hidden rounded-full bg-muted',
        className
      )}
    >
      {children}
    </span>
  );
}

export function AvatarImage({ src, alt }: { src: string; alt: string }) {
  return <img src={src} alt={alt} className="aspect-square h-full w-full object-cover" />;
}

export function AvatarFallback({ children }: { children: ReactNode }) {
  return (
    <span className="flex h-full w-full items-center justify-center bg-strong text-sm font-semibold text-muted">
      {children}
    </span>
  );
}
